import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PersonClient } from '@models/clients';
import { IDVStatus } from '@models/idv';
import { IdvService } from '@services/idv/idv.service';
import {
	IdvReviewModalComponent,
	IdvReviewModalData,
} from '../../idv-review-modal.component';

@Component({
	selector: 'app-review-report',
	templateUrl: './review-report.component.html',
	styleUrls: ['./review-report.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ReviewReportComponent {
	public googleSrcUrl;
	public showDelete = false;
	public fileName: string;
	public fileType: string;
	public isFlagging: boolean = false;
	public isVerifying: boolean = false;
	public viewOnly: boolean = false;
	public client: PersonClient;
	public reviewModalData: IdvReviewModalData;

	@Input() set data(value: IdvReviewModalData) {
		this.reviewModalData = value;

		this.googleSrcUrl = this.reviewModalData.googleSrcUrl;
		this.showDelete = this.reviewModalData.showDelete;
		this.fileName = this.reviewModalData.fileName;
		this.fileType = this.reviewModalData.fileType;
		this.client = this.reviewModalData.client;
		this.viewOnly = this.reviewModalData.viewOnly;
	}

	@Output() public stepCountChange = new EventEmitter<number>();

	constructor(
		public dialogRef: MatDialogRef<IdvReviewModalComponent>,
		private idvService: IdvService,
	) {}

	verifyReport() {
		this.stepCountChange.emit(2);
	}

	flagReport() {
		this.isFlagging = true;
		this.idvService.setIdvStatus(this.client?.idv, IDVStatus.FLAGGED).subscribe(
			() => {
				this.isFlagging = false;
				this.close();
			},
			(error) => {
				this.isFlagging = false;
				console.error(error);
			},
		);
	}

	close() {
		this.dialogRef.close();
	}
}
